import { Box, Stack, Typography } from "@mui/material";

function escapeHtml(text) {
  return String(text || "").replace(/[&<>"']/g, (char) => {
    const entities = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    };

    return entities[char] || char;
  });
}

function hasHtmlTag(value) {
  return /<\/?[a-z][\s\S]*>/i.test(String(value || ""));
}

function normalizeNbsp(value) {
  return String(value || "").replace(/&(?:amp;)?nbsp;|\u00a0/gi, " ");
}

function normalizeContent(content) {
  const normalized = normalizeNbsp(content);

  if (hasHtmlTag(normalized)) return normalized;

  return normalized
    .split("\n")
    .map((line) => {
      const trimmed = line.trim();
      return trimmed ? `<p>${escapeHtml(trimmed)}</p>` : "<br>";
    })
    .join("");
}

export default function RichTextViewer({
  content,
  title,
  showTitle = true,
}) {
  if (!content) {
    return (
      <Box sx={{ p: 2, color: "neutral.600" }}>
        <Typography>No hay contenido disponible</Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2}>
      {showTitle && title && (
        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "primary.900" }}>
          {title}
        </Typography>
      )}
      <Box
        sx={{
          p: 2,
          bgcolor: "white",
          borderRadius: "12px",
          border: "1px solid",
          borderColor: "neutral.200",
          fontSize: "14px",
          lineHeight: "1.6",
          color: "primary.900",
          "& h1": {
            fontSize: "28px",
            fontWeight: 700,
            margin: "0.5em 0",
          },
          "& h2": {
            fontSize: "22px",
            fontWeight: 700,
            margin: "0.5em 0",
          },
          "& h3": {
            fontSize: "18px",
            fontWeight: 700,
            margin: "0.5em 0",
          },
          "& p": {
            margin: "0.5em 0",
          },
          "& ul, & ol": {
            marginLeft: "1.5em",
            marginBottom: "0.5em",
          },
          "& li": {
            marginBottom: "0.25em",
          },
          "& a": {
            color: "#0056b3",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: 700,
            "&:hover": {
              color: "#004494",
              textDecoration: "underline",
            },
          },
          "& strong, & b": {
            fontWeight: 700,
          },
          "& em, & i": {
            fontStyle: "italic",
          },
          "& u": {
            textDecoration: "underline",
          },
          "& s, & strike": {
            textDecoration: "line-through",
          },
        }}
        dangerouslySetInnerHTML={{ __html: normalizeContent(content) }}
      />
    </Stack>
  );
}
